// Функция для проверки, нужно ли переводить переданный label через I18n
export function checkLabelTranslation(label) {
  const roomTitles = ['studio'];
  const key = roomTitles.find((title) => title === label);
  if (key) {
    return true;
  }
  return false;
}
